import React from 'react';
import { Droplet, Wind, Building2 } from 'lucide-react';
import { useLang } from '../contexts/LanguageContext';

const icons = [Droplet, Wind, Building2];

const About = () => {
  const { t } = useLang();
  return (
    <section id="about" className="relative py-32 md:py-40 overflow-hidden">
      <div className="max-w-[1600px] mx-auto px-6 md:px-10">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-8 mb-16">
          <div className="md:col-span-3">
            <div className="font-mono text-[11px] tracking-[0.35em] text-[#c99a3d] mb-3">{t.about.kicker}</div>
            <div className="font-serif italic text-cream/70 text-lg">{t.about.subkicker}</div>
          </div>
          <div className="md:col-span-9">
            <h2 className="font-serif text-cream font-light text-[42px] md:text-[64px] leading-[1.05] tracking-tight">
              {t.about.titleA} <span className="italic text-[#c99a3d]">{t.about.titleAccent}</span><br />
              {t.about.titleB}
            </h2>
            <p className="mt-8 max-w-[760px] text-cream/70 text-[16px] leading-[1.85]">{t.about.body}</p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mt-24">
          {t.about.pillars.map((p, i) => {
            const Icon = icons[i];
            return (
              <div key={i} className="card-lift relative border border-cream/10 rounded-sm p-8 bg-[#0d1526]/60 backdrop-blur-sm min-h-[240px]">
                <div className="flex items-center justify-between mb-8">
                  <Icon className="w-6 h-6 text-[#c99a3d]" strokeWidth={1.4} />
                  <span className="font-mono text-[10px] tracking-[0.3em] text-cream/45">0{i + 1}</span>
                </div>
                <h3 className="font-serif text-cream text-3xl mb-4">{p.title}</h3>
                <p className="text-cream/65 text-[14px] leading-[1.75]">{p.body}</p>
              </div>
            );
          })}
        </div>

        <div className="mt-32 md:mt-40 space-y-20">
          {t.about.chapters.map((c) => (
            <div key={c.n} className="grid grid-cols-1 md:grid-cols-12 gap-8 items-start border-t border-cream/10 pt-14">
              <div className="md:col-span-3">
                <div className="font-mono text-[11px] tracking-[0.35em] text-cream/45">{t.about.chapter} {c.n}</div>
                <div className="mt-6 font-serif text-6xl text-[#c99a3d]/70 font-light">{c.n}</div>
              </div>
              <div className="md:col-span-9">
                <h3 className="font-serif text-cream text-[32px] md:text-[42px] leading-[1.15] font-light max-w-[820px]">{c.title}</h3>
                <p className="mt-6 max-w-[760px] text-cream/65 text-[16px] leading-[1.85]">{c.body}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default About;
